import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../common/Modal';
import Icon, { GLYPHS } from '../../common/icon';
import { t } from '../../../modules/infra/i18n';

const AutoPayoutDeclinedFeedbackModal = ({
  onCloseClickedHandler,
  onSubmitDeclineFeedbackHandler,
  feedback,
  setFeedback,
}) => (
  <Modal
    close={onCloseClickedHandler}
    className="c-suggest-auto-payout-modal c-modal-new"
    showCloseButton
  >
    <div
      className="o-flexbox o-flexbox--content-align-center o-flexbox--column u-p+"
      data-automation-id="auto-payout-declined-feedback-modal"
    >
      <Icon glyph={GLYPHS.capitalV2} size="large" className="c-modal-new__header-icon" />
      <div className="c-modal-new__header">
        {t('common:declined_feedback_modal.title')}
      </div>
      <p className="c-modal-new__text">
        {t('common:declined_feedback_modal.description')}
      </p>
      <textarea
        rows="3"
        className="c-textarea u-bg-white u-mt"
        placeholder={t('common:declined_feedback_modal.placeholder')}
        value={feedback}
        onChange={e => setFeedback(e.target.value)}
        data-automation-id="auto-payout-suggestion-feedback-input"
      />
      <button
        className="c-btn c-btn--medium u-mt+ u-width-100"
        onClick={onSubmitDeclineFeedbackHandler}
        data-automation-id="auto-payout-suggestion-submit-feedback-button"
      >
        {t('common:declined_feedback_modal.submit_button')}
      </button>
    </div>
  </Modal>
);

AutoPayoutDeclinedFeedbackModal.propTypes = {
  onCloseClickedHandler: PropTypes.func.isRequired,
  onSubmitDeclineFeedbackHandler: PropTypes.func.isRequired,
  feedback: PropTypes.string.isRequired,
  setFeedback: PropTypes.func.isRequired,
};

export default AutoPayoutDeclinedFeedbackModal;
